import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { faBars } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Checkbox, TableCell, TableRow } from '@mui/material';
import { flexRender } from '@tanstack/react-table';
import { type CSSProperties, useMemo } from 'react';
import classSet from 'react-classset';

type Props = {
  row: any;
  selectedRowId?: string;
  showRowSelection?: boolean;
  rowSelection?: Record<string, boolean>;
  handleRowSelect?: (rowId: string) => void;
  sortable?: boolean;
  rowRefs?: any;
};

const VNTableRow = ({
  row,
  selectedRowId = '',
  showRowSelection = false,
  rowSelection = {},
  handleRowSelect,
  sortable,
  rowRefs,
}: Props) => {
  const { transform, transition, setNodeRef, isDragging, attributes, listeners } = useSortable({
    id: row.id,
  });
  const style: CSSProperties = {
    transform: CSS.Transform.toString(transform), // let dnd-kit do its thing
    transition,
    opacity: isDragging ? 0.8 : 1,
    zIndex: isDragging ? 1 : 0,
    position: 'relative',
  };

  const isSelected = useMemo(() => row.id === selectedRowId || row.original?.id === selectedRowId, [selectedRowId]);

  return (
    <TableRow
      key={row.id}
      className={classSet({ 'hover-row': true, highlight: isSelected })}
      style={style}
      ref={(el) => {
        setNodeRef(el);
        if (rowRefs.current && row && row.original && row.original.id) {
          rowRefs.current[row.original.id] = el;
        }
      }}
    >
      {sortable && (
        <TableCell className="sort-cell" {...attributes} {...listeners}>
          <span>
            <FontAwesomeIcon icon={faBars} />
          </span>
        </TableCell>
      )}
      {showRowSelection && (
        <TableCell className="checkbox-cell">
          <Checkbox size="small" checked={!!rowSelection[row.id]} onChange={() => handleRowSelect(row.id)} />
        </TableCell>
      )}
      {row.getVisibleCells().map((cell: any) => (
        <TableCell
          key={cell.id}
          sx={{
            textAlign: cell.column.columnDef.meta?.style?.textAlign || 'center',
            // backgroundColor: isSelected ? "#e3f2fd" : "transparent"
            maxWidth: cell.column.columnDef.size || 'auto',
          }}
        >
          {flexRender(cell.column.columnDef.cell, cell.getContext())}
        </TableCell>
      ))}
    </TableRow>
  );
};

export default VNTableRow;
